import { seoSections } from "@/mocks/categories";

export default function ComparisonTable() {
  const { comparison } = seoSections;

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Comparação
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            {comparison.title}
          </h2>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-200/50">
                <th className="py-4 px-5 text-xs font-semibold text-foreground-700 uppercase tracking-wider">
                  Plataforma
                </th>
                <th className="py-4 px-5 text-xs font-semibold text-foreground-700 uppercase tracking-wider">
                  Preço
                </th>
                <th className="py-4 px-5 text-xs font-semibold text-foreground-700 uppercase tracking-wider">
                  Velocidade
                </th>
                <th className="py-4 px-5 text-xs font-semibold text-foreground-700 uppercase tracking-wider">
                  Confiabilidade
                </th>
                <th className="py-4 px-5 text-xs font-semibold text-foreground-700 uppercase tracking-wider">
                  Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {comparison.platforms.map((p, idx) => (
                <tr
                  key={p.name}
                  className={`border-t border-background-200/40 ${
                    idx === 0
                      ? "bg-primary-50/30"
                      : "hover:bg-background-50"
                  }`}
                >
                  <td className="py-4 px-5">
                    <span
                      className={`text-sm font-semibold whitespace-nowrap ${
                        idx === 0 ? "text-primary-700" : "text-foreground-800"
                      }`}
                    >
                      {idx === 0 && "★ "}{p.name}
                    </span>
                  </td>
                  <td className="py-4 px-5">
                    <span className="inline-flex px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                      {p.price}
                    </span>
                  </td>
                  <td className="py-4 px-5 text-sm text-foreground-700">{p.speed}</td>
                  <td className="py-4 px-5 text-sm text-foreground-700">{p.reliability}</td>
                  <td className="py-4 px-5">
                    <span
                      className={`text-sm font-medium ${
                        p.spreadsheet === "Sim"
                          ? "text-accent-600"
                          : "text-foreground-400"
                      }`}
                    >
                      {p.spreadsheet}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-foreground-400 text-center mt-4">
          * Dados atualizados em Junho 2026. O Hoobuy Spreadsheet oferece a melhor relação custo-benefício do mercado.
        </p>
      </div>
    </section>
  );
}